import { useLocation, Navigate, RouteProps } from 'react-router-dom';
import React, { ReactElement } from 'react';
import { ROUTES } from 'constants/routes';
import { useAuth } from 'contexts/authContext';
import { getItem } from '@utils/localStorage';

interface ProtectedRouteProps extends Omit<RouteProps, 'children'> {
  children: ReactElement;
}

const WithAuth: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();

  const { isLoggedIn } = useAuth();
  const temp = getItem('isLoginInitiated');

  return isLoggedIn || temp ? (
    children
  ) : (
    <Navigate
      to={{ pathname: ROUTES.LOGIN.path, search: location.search }}
      replace
    />
  );
};

export default WithAuth;
